var exports = {
  "v0": "ProfileCardActions.module__iconMedium___dU9rSE",
  "wf": "ProfileCardActions.module__noteButtonContainer___dU9rSE",
  "_b": "ProfileCardActions.module__noteButtonContainerVisible___dU9rSE",
  "VI": "ProfileCardActions.module__noteButton___dU9rSE",
  "lY": "ProfileCardActions.module__noteTooltipContent___dU9rSE",
  "fg": "ProfileCardActions.module__noteIconWrapper___dU9rSE",
  "O8": "ProfileCardActions.module__copyIdButtonContainer___dU9rSE",
  "wG": "ProfileCardActions.module__copyIdButtonContainerVisible___dU9rSE",
  "pm": "ProfileCardActions.module__copyIdButton___dU9rSE",
  "Jt": "ProfileCardActions.module__copyIdIconWrapper___dU9rSE",
};

module.exports = exports;
